// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoriesPage_CategoriesPage__lT6cH {
  display: flex;
  justify-content: center;
  width: 100%;
}
.CategoriesPage_CategoriesPage__lT6cH .CategoriesPage_RightSide__yKhRY {
  padding: 20px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/CategoriesPage/CategoriesPage.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AACJ;AACI;EACI,aAAA;EACA,WAAA;AACR","sourcesContent":[".CategoriesPage {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    .RightSide {\n        padding: 20px;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CategoriesPage": `CategoriesPage_CategoriesPage__lT6cH`,
	"RightSide": `CategoriesPage_RightSide__yKhRY`
};
export default ___CSS_LOADER_EXPORT___;
